import support from "./support.js";

export default {
  discountCodeSave(data) {
    return support.post("Cart/discountCodeSave", data);
  },

  getBaseDiscount() {
    return support.get("Cart/getBaseDiscount");
  },

  baseDiscountSave(data) {
    return support.post("Cart/baseDiscountSave", data);
  },

  cartDiscountSave(data) {
    return support.post("Cart/cartDiscountSave", data);
  },

  getCartDiscount(uid) {
    return support.get("Cart/getCartDiscount/" + uid);
  },

  getCartDiscountList() {
    return support.get("Cart/getCartDiscountList");
  }
}
